import { z, uuidSchema } from '@kc3/validation';
/**
 * Resource-shape contracts for the multi-account Accounts List / Add Account
 * UI, backed by the `connected_accounts` table. Kept separate from
 * events/channel.ts, which holds RabbitMQ event contracts, not resource shapes.
 */
export const ConnectedAccountStatusEnum = z.enum(['connected', 'expired', 'revoked']);
export const AuthTypeEnum = z.enum(['oauth', 'manual']);
export const ConnectedAccountSchema = z.object({
    id: uuidSchema,
    channel: z.enum(['email', 'sms', 'whatsapp', 'facebook', 'instagram', 'chat', 'youtube', 'x']),
    provider: z.string(),
    accountKey: z.string(),
    displayName: z.string(),
    connectedUser: z.string().nullable(),
    status: ConnectedAccountStatusEnum,
    authType: AuthTypeEnum,
    lastTokenRefresh: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
export const ConnectedAccountsListResponseSchema = z.object({
    accounts: z.array(ConnectedAccountSchema),
});
export const AddManualAccountRequestSchema = z.object({
    channel: z.string(),
    provider: z.string(),
    displayName: z.string().min(1),
    /** Provider-specific manual fields (API key, tokens, etc.). */
    fields: z.record(z.string(), z.string()),
});
//# sourceMappingURL=connected-account.js.map